/**
 * Scroll to Top Button
 * Shows/hides button based on scroll position and scrolls smoothly to top when clicked
 */

$(document).ready(function () {
  const $scrollBtn = $('#scroll-to-top');

  function toggleScrollButton() {
    if ($(window).scrollTop() > 100) {
      $scrollBtn.addClass('visible');
    } else {
      $scrollBtn.removeClass('visible');
    }
  }

  $scrollBtn.on('click', function () {
    $('html, body').animate(
      {
        scrollTop: 0,
      },
      600
    );
  });

  $(window).on('scroll', toggleScrollButton);

  toggleScrollButton();
});
